import { Vector3 } from "../../../../maths/Vector3";
export var ComputeCommandType;
(function (ComputeCommandType) {
    ComputeCommandType[ComputeCommandType["DispatchCompute"] = 0] = "DispatchCompute";
    ComputeCommandType[ComputeCommandType["SetRenderData"] = 1] = "SetRenderData";
    ComputeCommandType[ComputeCommandType["ClearBuffer"] = 2] = "ClearBuffer";
    ComputeCommandType[ComputeCommandType["CopyBufferToBuffer"] = 3] = "CopyBufferToBuffer";
    ComputeCommandType[ComputeCommandType["copyBufferToTexture"] = 4] = "copyBufferToTexture";
    ComputeCommandType[ComputeCommandType["copyTextureToBuffer"] = 5] = "copyTextureToBuffer";
    ComputeCommandType[ComputeCommandType["copyTextureToTexture"] = 6] = "copyTextureToTexture";
})(ComputeCommandType || (ComputeCommandType = {}));
export var EComputeCMDMemoryOperate;
(function (EComputeCMDMemoryOperate) {
    EComputeCMDMemoryOperate[EComputeCMDMemoryOperate["ClearBuffer"] = 0] = "ClearBuffer";
    EComputeCMDMemoryOperate[EComputeCMDMemoryOperate["BufferToBuffer"] = 1] = "BufferToBuffer";
    EComputeCMDMemoryOperate[EComputeCMDMemoryOperate["BufferToTexture"] = 2] = "BufferToTexture";
    EComputeCMDMemoryOperate[EComputeCMDMemoryOperate["TextureToBuffer"] = 3] = "TextureToBuffer";
    EComputeCMDMemoryOperate[EComputeCMDMemoryOperate["TextureToTexture"] = 4] = "TextureToTexture";
})(EComputeCMDMemoryOperate || (EComputeCMDMemoryOperate = {}));
export class CopyTextureInfo {
    constructor() {
        this.mipLevel = 0;
        this.origin = new Vector3(0, 0, 0);
    }
}
